import { MenuItem } from './menu.model';

export const ADMINMENU: MenuItem[] = [
  {
    id: 1,
    label: 'MENUITEMS.MENU',
    isTitle: true
  },
  {
    id:2,
    label: 'MENUITEMS.DASHBOARD',
    icon: 'ri-dashboard-2-line',
    link: ''
  },
  {
    id: 3,
    label: 'MENUITEMS.PROJECTS',
    icon: 'ri-folders-line',
    link: '/projects'
  },
  {
    id: 4,
    label: 'MENUITEMS.USERS',
    icon: 'ri-team-line',
    link: '/users'
  },
  {
    id: 7,
    label: 'MENUITEMS.CREATE.TEXT',
    icon: 'ri-folder-add-line',
    subItems:[
      {
        id: 8,
        label:'MENUITEMS.CREATE.LIST.ROLEASSIGN',
        parentId: 7,
				icon: 'ri-user-shared-line',
        modal: 'assignModal'
      },
      {
        id: 9,
        label:'MENUITEMS.CREATE.LIST.USERS',
        parentId: 7,
				icon: ' ri-user-add-line',
        modal: 'userModal'
      }
    ]
  },
	{
    id: 10,
    label: 'MENUITEMS.APIKEYS',
    icon: ' ri-key-2-line',
    link: '/api-keys'
  },
	{
    id: 10,
    label: 'MENUITEMS.APIDOCS',
    icon: ' ri-book-open-line',
    link: '/api-docs'
  }
];

export const REGULATORMENU: MenuItem[] = [
  {
    id: 1,
    label: 'MENUITEMS.MENU',
    isTitle: true
  },
  {
    id:2,
    label: 'MENUITEMS.DASHBOARD',
    icon: 'ri-dashboard-2-line',
    link: ''
  },
  {
    id: 3,
    label: 'MENUITEMS.CLIENTS',
    icon: 'ri-folders-line',
    link: '/clients'
  },
  {
    id: 4,
    label: 'MENUITEMS.VIOLATIONS',
    icon: 'ri-team-line',
    link: '/users'
  }  
];

export const OWNERMENU: MenuItem[] = [
  {
    id: 1,
    label: 'MENUITEMS.MENU',
    isTitle: true
  },
  {
    id:2,
    label: 'MENUITEMS.DASHBOARD',
    icon: 'ri-dashboard-2-line',
    link: ''
  },
  {
    id: 3,
    label: 'MENUITEMS.PROJECTS',
    icon: 'ri-folders-line',
    link: '/projects'
  },
  {
    id: 6,
    label: 'MENUITEMS.CREATE.TEXT',
    icon: 'ri-folder-add-line',
    subItems:[ 
      {
        id:7,
        label:'MENUITEMS.CREATE.LIST.ROLEASSIGN',
        parentId: 6,
				icon: 'ri-user-shared-line',
        modal: 'assignModal'
      },
      {
        id:8,
        label: 'MENUITEMS.CREATE.LIST.PROJECT',
        parentId: 6,
				icon: 'ri-folder-add-line',
        modal: 'projectModal'
      }
    ]
  }
];

export const EDITORMENU: MenuItem[] = [
  {
    id: 1,
    label: 'MENUITEMS.MENU',
    isTitle: true
  },
  {
    id:2,
    label: 'MENUITEMS.DASHBOARD',
    icon: 'ri-dashboard-2-line',
    link: ''
  },
  {
    id: 3,
    label: 'MENUITEMS.PROJECTS',
    icon: 'ri-folders-line',
    link: '/projects'
  }
];

export const ANALYSTMENU: MenuItem[] = [
  {
    id: 1,
    label: 'MENUITEMS.MENU',
    isTitle: true
  },
  {
    id:2,
    label: 'MENUITEMS.DASHBOARD',
    icon: 'ri-dashboard-2-line',
    link: ''
  },
  {
    id: 3,
    label: 'MENUITEMS.PROJECTS',
    icon: 'ri-folders-line',
    link: '/projects'
  }
];